export default class heroSlider {
    constructor(elm, args) {
        if (elm.querySelectorAll('.swiper-slide').length === 0) return;
        slidePerViews = 1.2;
        if (window.matchMedia('screen and (min-width: 992px) and (max-width: 1200px)').matches) {
            var slidePerViews = 2.2; 
        }
        this.elm = elm;
        this.options = {
            loop: false,
            slidesPerView: slidePerViews,
            spaceBetween: 15,
            pagination: {
                el: '.swiper-pagination', 
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            scrollbar: {
                el: '.swiper-scrollbar',
            },
            ...args,
        };

        this.swiper = import('swiper').then(slider => new slider.Swiper(this.elm, this.options));
    }

    update() {
        this.swiper.update();
    }

    destroy() {
        this.swiper.destroy();
    }
}
